var _defs, _path, _polygon, _path2, _path3, _polygon2, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViqNewLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e311c7ed-79f6-4a0d-837a-3bc50d5ab624",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 770.03 150.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a29ab05d-3b20-4e3d-a43e-5c8212e259ce{fill:#fff;}.b58d5647-aabb-4d62-af8c-040cf4717b16{fill:#be8ded;}.a1e84db8-9f16-4829-b0ad-5afe37ff58fd{fill:url(#f5f2c1d6-c749-4970-9c71-520b28066b14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f5f2c1d6-c749-4970-9c71-520b28066b14",
    x1: 67.36,
    y1: 164.99,
    x2: 67.36,
    y2: 29.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eca7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be8ded"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    d: "M226.83,73.18c-19.06,0-29.35,14.88-29.35,28.86v.1c0,14.17,10.29,29.05,29.35,29.05s29.35-14.88,29.35-29S245.9,73.18,226.83,73.18Zm0,45.73a16.24,16.24,0,0,1-16.27-16.67v-.1c0-9.69,7.29-16.78,16.27-16.78S243,92.45,243,102.14,235.82,118.91,226.83,118.91Z",
    transform: "translate(-27 -29.85)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    points: "353.97 43.3 336.81 43.3 320.56 67.03 320.56 30.86 306.36 30.86 306.36 101.34 320.56 101.34 320.56 77.71 336.93 101.3 354.17 101.3 334.07 72.36 353.97 43.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    d: "M293.83,85.36A15.93,15.93,0,0,1,309.3,97.05h13.44c-2.16-12.35-12.13-23.87-28.91-23.87-19.06,0-29.35,14.88-29.35,28.86v.1c0,14.17,10.29,29.05,29.35,29.05,16.75,0,26.72-11.48,28.9-23.87H309.27a15.93,15.93,0,0,1-15.44,11.59,16.24,16.24,0,0,1-16.27-16.67v-.1C277.56,92.45,284.85,85.36,293.83,85.36Z",
    transform: "translate(-27 -29.85)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    d: "M410.54,73.18c-19.07,0-29.35,14.88-29.35,28.86v.1c0,14.17,10.28,29.05,29.35,29.05,14.43,0,23.83-8.53,27.54-18.83H423.49a15.85,15.85,0,0,1-12.95,6.55A16.09,16.09,0,0,1,395,107.32h44.44a30.22,30.22,0,0,0,.46-5.18C439.89,88.06,429.6,73.18,410.54,73.18ZM395,97.05a16.13,16.13,0,0,1,31,0Z",
    transform: "translate(-27 -29.85)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    points: "440.99 30.86 426.8 30.86 426.8 43.3 419.98 43.3 419.98 57.49 426.8 57.49 426.8 101.34 440.99 101.34 440.99 57.49 448.09 57.49 448.09 43.3 440.99 43.3 440.99 30.86"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    x: 111.78,
    y: 43.34,
    width: 14.19,
    height: 58
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    d: "M186.31,97.47a23,23,0,0,0,3.81-13.14c0-7.81-3.15-15-9-19.15-3.81-2.76-10.09-4.47-21-4.47H153V73.18h8.28c4,0,7.43.58,10,2.19a12.12,12.12,0,0,1,5.24,10.2A13.19,13.19,0,0,1,172,95.85c-3,2.29-8,2.57-12.67,2.57h-2.76l18.95,32.77H190.4l-15.71-26.1C179.26,104,183.26,102,186.31,97.47Z",
    transform: "translate(-27 -29.85)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    d: "M517.05,60.78H488.93v70.33h10.26V107.32h17.86a23.27,23.27,0,1,0,0-46.54Zm0,36.27H499.19V71h17.86a13,13,0,1,1,0,26Z",
    transform: "translate(-27 -29.85)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    d: "M575.51,73.11h0A25.52,25.52,0,0,0,560,78.35V60.74H549.72v70.33H560v-.35h.12V98.78a15.42,15.42,0,0,1,30.83,0v31.94h10.26V98.78A25.68,25.68,0,0,0,575.51,73.11Z",
    transform: "translate(-27 -29.85)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    d: "M704.15,73.11a25.68,25.68,0,0,0-25.67,25.67v31.94h10.26V98.78a15.42,15.42,0,0,1,30.83,0v31.94h10.26V98.78A25.68,25.68,0,0,0,704.15,73.11Z",
    transform: "translate(-27 -29.85)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    d: "M640.29,73.11a29,29,0,1,0,29,29A29,29,0,0,0,640.29,73.11Zm0,47.78a18.76,18.76,0,1,1,18.76-18.76A18.78,18.78,0,0,1,640.29,120.89Z",
    transform: "translate(-27 -29.85)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a29ab05d-3b20-4e3d-a43e-5c8212e259ce",
    d: "M786.05,107.26h10.52a28.94,28.94,0,1,0-1.38,5.06H783.73A18.72,18.72,0,0,1,750,107.26h36.07ZM768,83.37a18.77,18.77,0,0,1,18,13.63H750A18.77,18.77,0,0,1,768,83.37Z",
    transform: "translate(-27 -29.85)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b58d5647-aabb-4d62-af8c-040cf4717b16",
    x: 35.38,
    y: 90.32,
    width: 9.96,
    height: 59.77
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "a1e84db8-9f16-4829-b0ad-5afe37ff58fd",
    d: "M52.43,135.11V165h-10V135.11Zm29.87,0V165h10V135.11Zm25.43-44.83v10h-10v9.94h0v0h-5.5v10h-10v-10H77.85v-10h-21v10H52.43v10h-10v-10H37v0h0v-9.94H27v-10H37v0h0v-10h10V59.75h5v-10h0v0h5.51v-10h5v-10h9.9v10h5v10h5.5v10h5V80.3h10v10ZM72.35,59.75H62.4V80.3h9.95Z",
    transform: "translate(-27 -29.85)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViqNewLogoWhite);
export default __webpack_public_path__ + "static/media/viq-new-logo-white.443394bc5365c38f01eb6f8734a0e36c.svg";
export { ForwardRef as ReactComponent };